// React
import React, { HTMLInputTypeAttribute } from 'react'
// Styles
import * as Styled from './styles'
import { InputProps } from './styles'

interface Params {
  name: string
  placeholder?: string
  type?: HTMLInputTypeAttribute
  disabled?: boolean
  maxLength?: number
  mask?: string | Array<string | RegExp>
  tooltip?: string
  component: string
  value?: string | string[]
  required?: boolean
  options?: { name: string | undefined; value: string | undefined }[]
  multiple?: boolean
  presetStyles?: InputProps
  cols?: string
  rows?: string
  icon?: React.ReactNode
  onIconClick?: () => void
  iconAriaLabel?: string
  onChange?: React.ChangeEventHandler<any>
  onBlur?: React.FocusEventHandler<any>
}

function Input(props: Params) {
  const {
    name,
    placeholder,
    type = 'text',
    disabled = false,
    mask = '',
    component,
    presetStyles,
    cols,
    rows,
    icon,
    onIconClick,
    iconAriaLabel,
    onChange,
    onBlur,
  } = props
  const inputProps = { name, component, placeholder, mask, type, disabled, cols, rows, onChange, onBlur }

  if (props.component === 'select') {
    return (
      <>
        <Styled.Input {...inputProps} preset={presetStyles}>
          <option value="">---</option>
          {props.options?.map((item, index) => (
            <option key={`item.name-${index}`} value={item.value}>
              {item.name}
            </option>
          ))}
        </Styled.Input>
      </>
    )
  }

  if (props?.mask) {
    return (
      <Styled.Input {...inputProps} preset={presetStyles}>
        {({ field }) => (
          <Styled.StyledMaskedInput
            preset={presetStyles}
            {...field}
            mask={mask}
            onChange={onChange || field.onChange}
            onBlur={onBlur || field.onBlur}
          />
        )}
      </Styled.Input>
    )
  }

  if (icon) {
    return (
      <Styled.InputContainer withIcon>
        <Styled.Input {...inputProps} preset={presetStyles} />
        <Styled.IconButton type="button" aria-label={iconAriaLabel || 'input action'} onClick={onIconClick}>
          {icon}
        </Styled.IconButton>
      </Styled.InputContainer>
    )
  }

  return <Styled.Input {...inputProps} preset={presetStyles} />
}

export default Input
